/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-20T16:29:36-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-12T15:38:29-07:00
*/



import React, { Component } from 'react';
import { css } from 'aphrodite/no-important'
import style from './style';
import Button from '../../../blocks/Button';
import Headline from '../../../common/Headline';

class MsgComposer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      message: ''
    }

    this.messageChangeHandler = this.messageChangeHandler.bind(this);
    this.messageSubmitFormHandler = this.messageSubmitFormHandler.bind(this);
  }

  messageChangeHandler(e) {
    // record message
    this.setState({message: e.target.value});
  }

  messageSubmitFormHandler(e) {
    e.preventDefault();
    // submit message
    this.props.submitMessage(this.state.message);
    // reset message
    this.setState({message: ''});
  }

  render() {

    // do not allow messages to admin.
    if(this.props.username === 'admin') return null;

    if(this.props.canMsg) {
      // user can send messages
      return (
        <form onSubmit={this.messageSubmitFormHandler}>
        <div className={css(style.composer)}>
          <div className={css(style.container)}>
            <textarea className={css(style.textarea)} onChange={this.messageChangeHandler} value={this.state.message} />
          </div>
          <div className={css(style.sendContainer)}>
            <Button variant="primary" type="submit">Send</Button>
          </div>
        </div>
        </form>
      );
    } else {


      if(this.props.spamFlagged === true) {
        return (
          <div className={css(style.composer, style.composerReplacement)}>
            <Headline extraStyles={{marginBottom: '12px'}} size='XS'>Your account has been limited and you cannot send messages at this time.
            Please contact a member of support for more information.</Headline>
          </div>

        )
      }
      else if(this.props.sex === "Female") {
        // female activate prompt
        return (
          <div className={css(style.composer, style.composerReplacement)}>
            <Headline extraStyles={{marginBottom: '12px'}} size='XS'>You must confirm your account before sending messages.</Headline>
          </div>

        )
      } else {
        // male upgrade prompt.
        return (
          <div className={css(style.composer, style.composerReplacement)}>
            <Headline extraStyles={{marginBottom: '12px'}} size='XS'>Upgrade to read and send unlimited messages.</Headline>
            <Button to='/billing' variant='primary'>Upgrade</Button>
          </div>
        )
      }

    }

  }
}

export default MsgComposer;



// WEBPACK FOOTER //
// ./src/components/pages/Mail/MsgComposer/index.jsx